import React from "react";
import css from "./ConfigBlog.module.css";
import DefaultConfigSection from "./DefaultConfigSection/DefaultConfigSection";
import CustomConfigSection from "./CustomConfigSection/CustomConfigSection";
import {BlogView,SectionView} from "Components";


export default function ConfigBlog(){
    return (
        <BlogView className={css.configblog}>
            <SectionView 
                //title="vritra-scripts"
                text={`
                    a vritra-themed app includes by default the 
                    <a href="https://github.com/AhmedAyachi/Vritra-Scripts">vritra-scripts</a>
                    package as a development dependency.
                    @the vritra-scripts package is using webpack under the hood to configure
                    your app with a minimal usually sufficient configuration. 
                    @the vritra-scripts package can run your app in three different modes,
                    <b>development</b>,<b>testing</b> and <b>production</b> each with its default configuration
                `}
            />
            <DefaultConfigSection/>
            <CustomConfigSection/>
        </BlogView>
    )
}
